// extracted by css-extract-rspack-plugin
export default {"cls1":"Home-cls1_m-N","cls2":"Home-cls2_mm2 Home-cls1_m-N"};